import "./styles.scss";

import React, { useEffect, useRef } from "react";
import Slider from "react-slick";
import queryString from "query-string";

import SimpleContent from "components/SimpleContent";

const Content = ({ slides, search }) => {
  const sliderRef = useRef(null);

  const handleScroll = () => {
    const element = document.querySelector("#content_anchor");

    if (element) element.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const settings = {
    className: "main-content__slider",
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    fade: true,
    adaptiveHeight: true,
    beforeChange: () => handleScroll(),
  };

  const parsed = queryString.parse(search);

  useEffect(() => {
    if (parsed?.anchor) {
      const index = parseInt(parsed.anchor);

      if (!isNaN(index) && sliderRef.current) {
        handleScroll();

        sliderRef.current.slickGoTo(index - 1);
      }
    }
  }, [parsed]);

  return (
    slides?.length > 0 && (
      <section className="main-content">
        <div className="container">
          {
            <Slider {...settings} ref={sliderRef}>
              {slides.map((item, index) => {
                return item.contents?.length > 0 ? (
                  <div key={index}>
                    {item.contents.map((item, index) => (
                      <SimpleContent
                        key={index}
                        description={item.description}
                      />
                    ))}
                  </div>
                ) : null;
              })}
            </Slider>
          }
        </div>
        <div id="content_anchor" className="anchor" />
      </section>
    )
  );
};

export default Content;
